import React, {Fragment} from "react"
import { Link } from "react-router-dom"

const featureContent = [
    {
        arrow: "bi bi-arrow-up-right",
        frontIcon: "icon-3a",
        backIcon: "icon-3w",
        title: "Diseño Web",
        desc: "Proporcionamos de manera eficiente soluciones transparentes antes de recurrir a fuentes internas u 'orgánicas'.",
        pview: "324 Proyectos",
        dataAos:"fade-up",
        dataDelay:""
    }, {
        arrow: "bi bi-arrow-up-right",
        frontIcon: "icon-4a",
        backIcon: "icon-4w",
        title: "Desarrollo Web",
        desc: "Proporcionamos de manera eficiente soluciones transparentes antes de recurrir a fuentes internas u 'orgánicas'.",
        pview: "420 Proyectos",
        dataAos:"fade-up",
        dataDelay:"50"
    }, {
        arrow: "bi bi-arrow-up-right",
        frontIcon: "icon-5a",
        backIcon: "icon-5w",
        title: "Diseño UI/UX",
        desc: "Proporcionamos de manera eficiente soluciones transparentes antes de recurrir a fuentes internas u 'orgánicas'.",
        pview: "231 Proyectos",
        dataAos:"fade-up",
        dataDelay:"100"
    }, {
        arrow: "bi bi-arrow-up-right",
        frontIcon: "icon-6a",
        backIcon: "icon-6w",
        title: "Seguridad Web",
        desc: "Proporcionamos de manera eficiente soluciones transparentes antes de recurrir a fuentes internas u 'orgánicas'.",
        pview: "121 Proyectos",
        dataAos:"fade-up",
        dataDelay:"150"
    }, {
        arrow: "bi bi-arrow-up-right",
        frontIcon: "icon-7a",
        backIcon: "icon-7w",
        title: "Marketing Digital",
        desc: "Proporcionamos de manera eficiente soluciones transparentes antes de recurrir a fuentes internas u 'orgánicas'.",
        pview: "501 Proyectos",
        dataAos:"fade-up",
        dataDelay:"200"
    }, {
        arrow: "bi bi-arrow-up-right",
        frontIcon: "icon-8a",
        backIcon: "icon-8w",
        title: "Programación",
        desc: "Proporcionamos de manera eficiente soluciones transparentes antes de recurrir a fuentes internas u 'orgánicas'.",
        pview: "224 Proyectos",
        dataAos:"fade-up",
        dataDelay:"250"
    }
]

const FeatureOne = () => {
    return (
        <Fragment>
            {featureContent.map((val, i) => (
                <div key={i} className="col-lg-4 col-md-6" data-aos={val.dataAos} data-aos-delay={val.dataDelay}>
                    <div className="feature-style-one mb-45">
                        <a className="top-arrow" href="#">
                            <i className={val.arrow}/>
                        </a>
                        <img className="front-icon" src={`assets/img/icon/${val.frontIcon}.png`} alt={`Icono servicio ${val.title}`}/>
                        <img className="back-icon" src={`assets/img/icon/${val.backIcon}.png`} alt={`Icono servicio ${val.title}`}/>
                        <h2>
                            <Link to="/services-details">{val.title}</Link>
                        </h2>
                        <p>{val.desc}</p>
                        <Link to="/project-grid">324 Proyectos</Link>
                    </div>
                </div>
            ))}
        </Fragment>
    )
}

export default FeatureOne